import React, { useCallback, useRef } from 'react';
import { ColDef } from 'ag-grid-community';
import { ReceptionListItem } from '../../models/Reception';
import { AgGridTable, AgGridTableRef } from '@shared/components/ui/AgGridTable';
import { useAgGridColumns } from '../../hooks/useAgGridColumns';

interface ReceptionAgGridTableProps {
  receptions: ReceptionListItem[];
  isLoading?: boolean;
  isFetching?: boolean;
  className?: string;
  // Props para handlers de acciones
  onEdit?: (reception: ReceptionListItem) => void;
  onDelete?: (reception: ReceptionListItem) => void;
  // Props para infinite scroll
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  // Props para sorting personalizado
  sorting?: { field: string; direction: 'asc' | 'desc' } | null;
  onSortingChange?: (
    sorting: { field: string; direction: 'asc' | 'desc' } | null
  ) => void;
  // Permisos
  canEdit?: boolean;
  canDelete?: boolean;
}

/**
 * Tabla AG Grid para mostrar recepciones
 */
export const ReceptionAgGridTable = React.memo(function ReceptionAgGridTable({
  receptions,
  isFetching = false,
  onEdit,
  onDelete,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  sorting,
  onSortingChange,
  canEdit = true,
  canDelete = true,
}: ReceptionAgGridTableProps) {
  const agGridRef = useRef<AgGridTableRef>(null);

  // Handler no-op para onGridReady
  const handleGridReady = useCallback(() => {}, []);

  // Usar el hook para manejar las columnas
  const { filteredColumnDefs } = useAgGridColumns({
    onEdit: canEdit ? onEdit : undefined,
    onDelete: canDelete ? onDelete : undefined,
  });

  const columnDefsWithRenderers: ColDef[] = filteredColumnDefs;

  return (
    <div
      className={`w-full ${isFetching && !isFetchingNextPage ? 'opacity-50 pointer-events-none' : ''}`}
    >
      <AgGridTable
        ref={agGridRef}
        data={receptions}
        columnDefs={columnDefsWithRenderers}
        height="calc(100vh - 150px)"
        enableSelection={false}
        onGridReady={handleGridReady}
        className="rounded-lg shadow-sm"
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        gridOptions={{}}
        sorting={sorting}
        onSortingChange={onSortingChange}
      />
    </div>
  );
});

export default ReceptionAgGridTable;

